// 员工档案 接口相关
import request from "../../untils/request.js"


export const supplierStatis = (params) => {
    return request.get("/outpatient/supplier/supplierStatis", {params} )
}

export const supplierPaidChgPage = (params) => {
    return request.get("/outpatient/paidChg/page", {params} )
}